import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const Ctx = createContext(null);
export const useAuth = () => useContext(Ctx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = anon

  const check = () => {
    if (!localStorage.getItem("balboa_token")) {
      setUser(false);
      return Promise.resolve();
    }
    return api
      .get("/auth/me")
      .then((r) => setUser(r.data.user))
      .catch(() => setUser(false));
  };

  useEffect(() => {
    check();
  }, []);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data.token) localStorage.setItem("balboa_token", data.token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("balboa_token");
    setUser(false);
  };

  return <Ctx.Provider value={{ user, login, logout, check }}>{children}</Ctx.Provider>;
};
